/**
 * `<countdown-timer>` custom element (v1.2).
 *
 * Ticks toward data-deadline (unix seconds). When the deadline passes the
 * whole element removes itself — the honest version of a countdown: the
 * Liquid already refuses to render an expired one, this handles the moment
 * it expires while the page is open. No resets, no loops.
 */
class CountdownTimer extends HTMLElement {
  connectedCallback() {
    this.deadline = Number(this.dataset.deadline) * 1000;
    this.els = {
      days: this.querySelector('[data-countdown-days]'),
      hours: this.querySelector('[data-countdown-hours]'),
      minutes: this.querySelector('[data-countdown-minutes]'),
      seconds: this.querySelector('[data-countdown-seconds]')
    };
    if (!this.deadline || !this.els.days) return;
    this.tick();
    this.interval = setInterval(() => this.tick(), 1000);
  }

  disconnectedCallback() {
    clearInterval(this.interval);
  }

  tick() {
    const left = this.deadline - Date.now();
    if (left <= 0) {
      clearInterval(this.interval);
      this.remove();
      return;
    }
    const s = Math.floor(left / 1000);
    this.els.days.textContent = String(Math.floor(s / 86400));
    this.els.hours.textContent = String(Math.floor((s % 86400) / 3600)).padStart(2, '0');
    this.els.minutes.textContent = String(Math.floor((s % 3600) / 60)).padStart(2, '0');
    this.els.seconds.textContent = String(s % 60).padStart(2, '0');
  }
}

if (!customElements.get('countdown-timer')) {
  customElements.define('countdown-timer', CountdownTimer);
}
